<template>
  <ul class="tag-list-base" :class="{clickable: linkEnable}">
    <li
      v-for="( item, index ) in tagListMod"
      :key="index"
      :class="getItemClass(index)"
      :data-myid="item.id"
      @click.stop="onItemClick(index)"
    >#{{ item.tagName }}</li>
  </ul>
</template>

<script>
export default {
  name: "TagList",
  props: {
    tagList: {
      type: Array,
      default() {
        return []
      }
    },
    linkEnable: {
      type: Boolean,
      default(){
        return false
      }
    },
    isMovieItem: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    tagListMod() {
      const rtn = []
      for(let item of this.tagList){
        if(!!item.tagName && /^[^_]/.test(item.tagName)){
          rtn.push(item)
        }
      }
      return rtn
    }
  },
  methods: {
    getItemClass(idx){
      const rtn = []
      if(this.linkEnable) rtn.push('clickable')
      return rtn.join(' ')
    },
    onItemClick( idx ) {
      if(this.linkEnable){
        location.href = `/tag/${this.tagListMod[idx].id}${this.isMovieItem ? '?movies=1' : ''}`
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.tag-list-base {
  li {
    display: inline;
    margin-right: 8px;
    font-size: 13px;
    line-height: 16px;
    transition: color 100ms ease-out 0s;
    pointer-events: none;
    &.clickable {
      pointer-events: auto;
      cursor: pointer;
      color: $col_temp_key1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/TagList.vue